// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

// roots path
const ROOTS_AUTH = '/auth';
const ROOTS_BLOG = '/blog';
const ROOTS_TOOLS = '/tools';
const ROOTS_DIRECTORY = '/directory';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_BIBLIOTECA = '/biblioteca';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  root: "/",
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  privacy: '/privacy',
  deleteAccount: '/delete-account',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  blog: {
    root: ROOTS_BLOG,
    view: (slug) => path(ROOTS_BLOG, `/post/${slug}`),
  },
  directory: {
    root: ROOTS_DIRECTORY,
    view: (id) => path(ROOTS_DIRECTORY, `/therapist/${id}`),
  },
  tools: {
    root: ROOTS_TOOLS,
    tarot: path(ROOTS_TOOLS, `/tarot`),
    tarotConsulta: path(ROOTS_TOOLS, `/tarot/consulta`),
    tarotThreeCards: path(ROOTS_TOOLS, `/tarot/three-cards`),
    tarotLectura: path(ROOTS_TOOLS, `/tarot/lectura`),
    biopairs: path(ROOTS_TOOLS, `/biopairs`),
    bachflowers: path(ROOTS_TOOLS, `/bach-flowers`),
    bachflowersConsulta: path(ROOTS_TOOLS, `/bach-flowers/consulta`),
    bachflowersCatalogo: path(ROOTS_TOOLS, `/bach-flowers/catalogo`),
    chakras: path(ROOTS_TOOLS, `/chakras`),
    chakrasConsulta: path(ROOTS_TOOLS, `/chakras/consulta`),
    chakrasCatalogo: path(ROOTS_TOOLS, `/chakras/catalogo`),
    numerology: path(ROOTS_TOOLS, `/numerology`),
    numerologyCarta: path(ROOTS_TOOLS, `/numerology/carta`),
    numerologyCompleta: path(ROOTS_TOOLS, `/numerology/completa`),
    numerologyConsulta: path(ROOTS_TOOLS, `/numerology/consulta`),
    numerologyConsultaMedida: path(ROOTS_TOOLS, `/numerology/consulta-medida`),
    numerologyBodaInicio: path(ROOTS_TOOLS, `/numerology/boda/inicio`),
    numerologyBoda: path(ROOTS_TOOLS, `/numerology/boda`),
    numerologyBodaLibro: path(ROOTS_TOOLS, `/numerology/boda/libro`),
    numerologyLectura: path(ROOTS_TOOLS, `/numerology/lectura`),
    numerologyCatalogo: path(ROOTS_TOOLS, `/numerology/catalogo`),
    astralchart: path(ROOTS_TOOLS, `/astralchart`),
    astralchartConsulta: path(ROOTS_TOOLS, `/astralchart/consulta`),
    astralchartLectura: path(ROOTS_TOOLS, `/astralchart/lectura`),
    astralchartCatalogo: path(ROOTS_TOOLS, `/astralchart/catalogo`),
    crystals: path(ROOTS_TOOLS, `/crystals`),
    crystalsConsulta: path(ROOTS_TOOLS, `/crystals/consulta`),
    crystalsCatalogo: path(ROOTS_TOOLS, `/crystals/catalogo`),
    sinastria: path(ROOTS_TOOLS, `/sinastria`),
    sinastriaConsulta: path(ROOTS_TOOLS, `/sinastria/consulta`),
    sinastriaLectura: path(ROOTS_TOOLS, `/sinastria/lectura`),
    suenos: path(ROOTS_TOOLS, `/suenos`),
    suenosConsulta: path(ROOTS_TOOLS, `/suenos/consulta`),
    suenosProfundo: path(ROOTS_TOOLS, `/suenos/profundo`),
    suenosLectura: path(ROOTS_TOOLS, `/suenos/lectura`),
    runas: path(ROOTS_TOOLS, `/runas`),
    runasConsulta: path(ROOTS_TOOLS, `/runas/consulta`),
    runasTirada: path(ROOTS_TOOLS, `/runas/tirada`),
    nahual: path(ROOTS_TOOLS, `/nahual`),
    nahualShared: (token) => path(ROOTS_TOOLS, `/nahual/r/${token}`),
    nahualSign: (slug) => path(ROOTS_TOOLS, `/nahual/signo/${slug}`),
    cartaNahual: path(ROOTS_TOOLS, `/carta-nahual`),
    cartaNahualLectura: path(ROOTS_TOOLS, `/carta-nahual/lectura`),
    quiromancia: path(ROOTS_TOOLS, `/quiromancia`),
    quiromanciaCompleta: path(ROOTS_TOOLS, `/quiromancia/completa`),
    quiromanciaLectura: path(ROOTS_TOOLS, `/quiromancia/lectura`),
    pastLives: path(ROOTS_TOOLS, `/lab/vidas-pasadas`),
    pastLivesShared: (token) => path(ROOTS_TOOLS, `/lab/vidas-pasadas/r/${token}`),
    directory: path(ROOTS_TOOLS, `/directory`),
  },
  store: {
    root: '/tienda',
    payment: '/tienda/pago',
  },
  biblioteca: {
    root: ROOTS_BIBLIOTECA,
    bachflowers: path(ROOTS_BIBLIOTECA, '/flores-de-bach'),
    chakras: path(ROOTS_BIBLIOTECA, '/chakras'),
    numerology: path(ROOTS_BIBLIOTECA, '/numerologia'),
    numerologyNumber: (n) => `/numerologia/numero/${n}`,
    planets: path(ROOTS_BIBLIOTECA, '/planetas'),
    crystals: path(ROOTS_BIBLIOTECA, '/cristales'),
    nahual: path(ROOTS_BIBLIOTECA, '/nahual'),
    nahualSign: (slug) => path(ROOTS_BIBLIOTECA, `/nahual/${slug}`),
    pastLives: path(ROOTS_BIBLIOTECA, '/vidas-pasadas'),
    pastLifeFigure: (slug) => path(ROOTS_BIBLIOTECA, `/vidas-pasadas/${slug}`),
  }
};


export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
  },
  admin: {
    root: path(ROOTS_DASHBOARD, '/admin'),
    metrics: path(ROOTS_DASHBOARD, '/admin/metrics'),
    projectMap: path(ROOTS_DASHBOARD, '/admin/mapa'),
    tarot: path(ROOTS_DASHBOARD, '/admin/tarot'),
    suenos: path(ROOTS_DASHBOARD, '/admin/suenos'),
    astralchart: path(ROOTS_DASHBOARD, '/admin/astralchart'),
    numerologia: path(ROOTS_DASHBOARD, '/admin/numerologia'),
    runas: path(ROOTS_DASHBOARD, '/admin/runas'),
    cartaNahual: path(ROOTS_DASHBOARD, '/admin/carta-nahual'),
    jobs: path(ROOTS_DASHBOARD, '/admin/jobs'),
    sendinblue: path(ROOTS_DASHBOARD, '/admin/sendinblue'),
    imageapproval: path(ROOTS_DASHBOARD, '/admin/imageapproval'),
    courtesies: path(ROOTS_DASHBOARD, '/admin/courtesies'),
    giftCodes: path(ROOTS_DASHBOARD, '/admin/gift-codes'),
    chatsEnVivo: path(ROOTS_DASHBOARD, '/admin/chats-en-vivo'),
  },
  biblioteca: {
    root: path(ROOTS_DASHBOARD, '/biblioteca'),
    bachflowers: path(ROOTS_DASHBOARD, '/biblioteca/flores-de-bach'),
    chakras: path(ROOTS_DASHBOARD, '/biblioteca/chakras'),
    numerology: path(ROOTS_DASHBOARD, '/biblioteca/numerologia'),
    planets: path(ROOTS_DASHBOARD, '/biblioteca/planetas'),
    crystals: path(ROOTS_DASHBOARD, '/biblioteca/cristales'),
    misRecursos: path(ROOTS_DASHBOARD, '/biblioteca/mis-recursos'),
  },
  biopairs: {
    root: path(ROOTS_DASHBOARD, '/biopairs'),
  },
  tools: {
    root: path(ROOTS_DASHBOARD, '/tools'),
    bachflowers: {
      root: path(ROOTS_DASHBOARD, '/tools/bach-flowers'),
      consulta: path(ROOTS_DASHBOARD, '/tools/bach-flowers/consulta'),
      completo: path(ROOTS_DASHBOARD, '/tools/bach-flowers/completo'),
      catalogo: path(ROOTS_DASHBOARD, '/tools/bach-flowers/catalogo'),
    },
    chakras: {
      root: path(ROOTS_DASHBOARD, '/tools/chakras'),
      consulta: path(ROOTS_DASHBOARD, '/tools/chakras/consulta'),
      catalogo: path(ROOTS_DASHBOARD, '/tools/chakras/catalogo'),
    },
    numerology: {
      root: path(ROOTS_DASHBOARD, '/tools/numerology'),
      consulta: path(ROOTS_DASHBOARD, '/tools/numerology/consulta'),
      consultaMedida: path(ROOTS_DASHBOARD, '/tools/numerology/consulta-medida'),
      boda: path(ROOTS_DASHBOARD, '/tools/numerology/boda'),
      lectura: path(ROOTS_DASHBOARD, '/tools/numerology/lectura'),
      catalogo: path(ROOTS_DASHBOARD, '/tools/numerology/catalogo'),
    },
    astralchart: {
      root: path(ROOTS_DASHBOARD, '/tools/astralchart'),
      consulta: path(ROOTS_DASHBOARD, '/tools/astralchart/consulta'),
      catalogo: path(ROOTS_DASHBOARD, '/tools/astralchart/catalogo'),
    },
    crystals: {
      root: path(ROOTS_DASHBOARD, '/tools/crystals'),
      consulta: path(ROOTS_DASHBOARD, '/tools/crystals/consulta'),
    },
    sinastria: {
      root: path(ROOTS_DASHBOARD, '/tools/sinastria'),
      consulta: path(ROOTS_DASHBOARD, '/tools/sinastria/consulta'),
    },
    suenos: {
      root: path(ROOTS_DASHBOARD, '/tools/suenos'),
      consulta: path(ROOTS_DASHBOARD, '/tools/suenos/consulta'),
      profundo: path(ROOTS_DASHBOARD, '/tools/suenos/profundo'),
    },
    runas: {
      root: path(ROOTS_DASHBOARD, '/tools/runas'),
      consulta: path(ROOTS_DASHBOARD, '/tools/runas/consulta'),
      tirada: path(ROOTS_DASHBOARD, '/tools/runas/tirada'),
    },
    nahual: {
      root: path(ROOTS_DASHBOARD, '/tools/nahual'),
      descubrir: path(ROOTS_DASHBOARD, '/tools/nahual/descubrir'),
      carta: path(ROOTS_DASHBOARD, '/tools/nahual/carta'),
    },
    quiromancia: {
      root: path(ROOTS_DASHBOARD, '/tools/quiromancia'),
      completa: path(ROOTS_DASHBOARD, '/tools/quiromancia/completa'),
      lectura: path(ROOTS_DASHBOARD, '/tools/quiromancia/lectura'),
    },
  },
  mystic: {
    root: path(ROOTS_DASHBOARD, '/mystic'),
    tarot: {
      root: path(ROOTS_DASHBOARD, '/mystic/tarot'),
      hub: path(ROOTS_DASHBOARD, '/mystic/tarot'),
      single: path(ROOTS_DASHBOARD, '/mystic/tarot/single'),
      daily: path(ROOTS_DASHBOARD, '/mystic/tarot/daily'),
      ask: path(ROOTS_DASHBOARD, '/mystic/tarot/ask'),
      history: path(ROOTS_DASHBOARD, '/mystic/tarot/history'),
      // Legacy aliases — mantener para backwards compat de URLs existentes
      reading: path(ROOTS_DASHBOARD, '/mystic/tarot/history'),
    },
  },
  store: {
    root: path(ROOTS_DASHBOARD, '/store'),
    memberships: path(ROOTS_DASHBOARD, '/store/memberships'),
    myOrders: path(ROOTS_DASHBOARD, '/store/my-orders'),
  },
  support: {
    root: path(ROOTS_DASHBOARD, '/support'),
    chat: path(ROOTS_DASHBOARD, '/support/chat'),
    guide: path(ROOTS_DASHBOARD, '/support/guide'),
  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    payments: path(ROOTS_DASHBOARD, '/user/payments'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
